import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthenticateState } from '../reducers/auth.reducer';

export const STORE_NAME = 'Auth';

const authState = createFeatureSelector<AuthenticateState>(STORE_NAME);

export const selectIsLoading = createSelector(authState, (state: AuthenticateState) => state.isLoading);

export const selectError = createSelector(authState, (state: AuthenticateState) => state.error);

export const selectToken = createSelector(authState, (state: AuthenticateState) => state.token);

export const selectIsAuthenticated = createSelector(selectToken, (token) => !!token);

export const selectHasLoadTokenFromLocaleStorageCompleted = createSelector(
  authState,
  (state: AuthenticateState) => state.hasLoadTokenFromLocaleStorageActionCompleted,
);

export const selectShowSuccessMessage = createSelector(authState, (state: AuthenticateState) => state.showSuccessMessage);

export const codeDeliveryDestination = createSelector(
  authState,
  (state: AuthenticateState) => state.loginResponse?.codeDeliveryDestination,
);

export const selectSsoLoginUrl = createSelector(authState, (state: AuthenticateState) =>
  state.ssoLogin?.identityProviders?.length ? state.ssoLogin.identityProviders[0].loginUrl : null,
);

export const sessionId = createSelector(authState, (state: AuthenticateState) => state.loginResponse?.sessionId);
export const credentials = createSelector(authState, (state: AuthenticateState) => state.credentials);
export const isInvitationValid = createSelector(authState, (state: AuthenticateState) => state.isInvitationValid);
